module.exports = "query GetFilters {\n  filters {\n    ...FilterFragment\n  }\n}\n"